import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Aba, ProcessoPorEstado } from './estados-processo.model';
import { ConsultasService } from '@app/services/consultas.service';
import { EstadoDoProcesso } from '@app/models/estado-do-processo.model';
import { RelatorioService } from '../../../services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr'
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-estados-processo',
  templateUrl: './estados-processo.component.html',
  styleUrls: ['./estados-processo.component.scss']
})
export class RelatorioEstadosProcessoComponent implements OnInit {

  consultaService: ConsultasService;
  relatorioService: RelatorioService;

  @ViewChild('relatorio') relatorio: ElementRef;
  abasEstados: Aba[] = [];
  abaSelecionada: boolean[] = [];

  tiposDeEstado: EstadoDoProcesso[];

  dataRelatorio: Date;
  dataInicio: Date;
  dataFim: Date;
  private dataChangeSubject = new Subject<string>();
  private inscricao: Subscription;
  dataFimHabilitada: boolean = false;

  constructor(
    protected _consultaService: ConsultasService,
    protected _relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {

    this.consultaService = _consultaService;
    this.relatorioService = _relatorioService;

    this.inscricao = this.dataChangeSubject.pipe(
      debounceTime(1400),
    ).subscribe(() => {
        this.RecriaAbaComFiltroData();
    });
  }

  ngOnInit() {
    this.consultaService.consultar('EstadoDoProcesso').toPromise().then((data: EstadoDoProcesso[]) => {
      this.tiposDeEstado = [...data];
      this.tiposDeEstado.forEach(() => this.abaSelecionada.push(false));
    });
  }

  get temAbasSelecionadas(): boolean {
    return this.abasEstados.length > 0;
  }

  onDataChange(){
    console.log('uma vez')
    this.dataChangeSubject.next();
  }

  RecriaAbaComFiltroData(){
    console.log('RecriaAbaComFiltroData')
    this.abasEstados.forEach(i => {
     this.relatorioService.processosPorEstado(i.id, this.dataInicio, this.dataFim).subscribe((registros: ProcessoPorEstado[]) => {
      if (!!registros && registros.length > 0) {
        this.abasEstados[this.abasEstados.length - 1].processos = registros;
      }
      else {
        this.abasEstados.pop();
        this.toastr.info("Nenhum resultado foi encontrado");
      }
    });
    })
  }

  criaAba(estado: EstadoDoProcesso, index: number) {
    this.dataRelatorio = new Date();
    this.abasEstados
      .push(
        {
          id: estado.Id,
          titulo: `${estado.Descricao}`,
          processos: []
        }
      );
    this.relatorioService.processosPorEstado(estado.Id, this.dataInicio, this.dataFim).subscribe((registros: ProcessoPorEstado[]) => {
      if (!!registros && registros.length > 0) {
        this.abasEstados[this.abasEstados.length - 1].processos = registros;
      }
      else {
        this.abasEstados.pop();
        this.toastr.info("Nenhum resultado foi encontrado");
      }
    });
    this.abaSelecionada[index] = true;
  }

  public imprimir(divId: string) {
    let conteudo = document.getElementById(divId).innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório estado de processo", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    objetoFiltros.set('Emitido em', this.dataRelatorio.toLocaleString('pt-BR'));
    
    if (this.dataInicio) {
      objetoFiltros.set('Data Início', new Date(this.dataInicio).toLocaleDateString('pt-BR'));
    }
    
    if (this.dataFim) {
      objetoFiltros.set('Data Fim', new Date(this.dataFim).toLocaleDateString('pt-BR'));
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    
    return stringHtml;
  }

  ngOnDestroy() {
    this.inscricao.unsubscribe();
  }
}
